const spin = {
  hidden: {
    rotate: '0deg',
    opacity: 0,
  },
  visible: {
    rotate: '360deg',
    opacity: 1,
    transition: {
      duration: 0.3,
      type: 'spring',
    },
  },
  exit: {
    rotate: '0deg',
    opacity: 0,
  },
};

export default spin;
